import { Component, OnInit, ViewEncapsulation, Input, ViewChild, ElementRef, Output, EventEmitter} from '@angular/core';
import { ApiService } from '../../../../api/api.service';
//import { Clinic } from '../../../../model/clinic';
import {Clinic} from '../../../../model/clinic';
import { FilterColumn } from '../model/FilterColumn';
import { FormsModule, ControlValueAccessor } from "@angular/forms";
import { ColumnConfig } from '../model/ColumnConfig';
import { CrudListConfiguration } from '../model/CrudListConfiguration';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { iListDataResponse } from '../model/iListDataResponse';
import { FilterFormComponent } from './components/filter-form/filter-form.component';
import { FormGroup } from '@angular/forms/src/model';
import { filterQueryId } from '@angular/core/src/view/util';
import  {ActionArgs} from '../model/ActionArgs';
import { FlashService } from '../../../services/flash.service';
import { NgbDateLocalParserFormatter } from '../../../providers/NgbDateLocalParserFormatter';
import { AuthGuard } from '../../../../shared/guard/index';

@Component({
  selector: 'app-crud-list',
  templateUrl: './crud-list.component.html',
  styleUrls: ['./crud-list.component.scss'],
  encapsulation: ViewEncapsulation.None,
  inputs:["listConfig:listConfig"],  
  
})
export class CrudListComponent implements OnInit {  
  
  //public filterConfig: Array<FilterColumn>;
  public _currentPage: number;
  //public columnConfig: any;  
  public _listConfig: CrudListConfiguration;
  public listData: any;
  public _filterData: any;
  public _columnConfig:Array<any>=[];
  public numbers:Array<number>;
  public err;
  public listItems:Array<any>;
  private _busy:boolean=false;
  private _date_format;
  private _date_formatter:NgbDateLocalParserFormatter = new NgbDateLocalParserFormatter();

  @ViewChild('filter') filter: FilterFormComponent;  
  
  @Output() onAction = new EventEmitter<ActionArgs>();

  constructor(private api: ApiService,public flash:FlashService
    ,private auth:AuthGuard
  ) {
      this._currentPage =1;        
      this._filterData=Array();      
      this.listData = {
        "items": {},
        "count": 0
      },      
      this.listItems=[],
      this._listConfig=null;      
      this._date_format = this._date_formatter.getLocaleDateString();
   }

  ngOnInit() {              
        
  }
  
  public toSimpleArray(objects: any[])
  {
    return Object.values(objects);    
  }

  public get isBusy()
  {
    return this._busy;
  }

  public refresh()
  {
    this.getList(this.filter.form);
  }

  public render_column_data(clx:ColumnConfig, row:any)
  {
    if(clx.datatype=="boolean")
    {
      return row[clx.field_name]?'Yes':'No';
    }
    else if(clx.datatype=="date")
    {
      var val = row[clx.field_name];
      if(val==null || val.length==0) return ' ';            

      return this._date_formatter.formatFromDateString(row[clx.field_name]);
    }    

    return row[clx.field_name];
  }

 public doFilter(filterForm:FormGroup)
 {
   this._currentPage=1;
   this.getList(filterForm);
 }

 public doReset()
 {
   this._currentPage=1;
   this.getList(null);
 }

  public getList(filterForm:FormGroup|any=null)
  {    
    var filterData=null;   
    
    if(this.filterConfig!=null && filterForm !=null)
    {      
      this.filterConfig.forEach((col)=>{
          var fld = filterForm.get(col.field_name);
          var op:string = fld.get('op').value;
          var value1:string = fld.get('value1').value;
          var value2:string = fld.get('value2').value;
          
          if(value1==undefined || value1.length==0)           
            return;
                      
          var fld_name:string=col.field_name;  

          if(filterData==null) filterData={};
          filterData[fld_name] =           
              {"op":op,"value1":value1,"value2":value2};
      });            
    }


    this.err = undefined;
    this._busy=true;

    var p = {
        api:this.api,
        listClass:this.listConfig.listClass,
        filterData:filterData,
        currentPage:this.currentPage, 
        maxPerPage:this.listConfig.maxPerPage,
        sortBy:this.listConfig.sortBy,
        sortDir:this.listConfig.sortDir        
    };

     /*api.list(this.listConfig.listClass, filterData,this.currentPage, this.listConfig.maxPerPage,this.listConfig.sortBy,this.listConfig.sortDir).subscribe
      (
        data =>{this.listOnSuccess(data);},
        err  => { this.listOnError(err, fn);}        
      );*/    
    
    this.doList(p);
  }

  public doList(params)
  { 
    params.api.list(params.listClass,
      params.filterData,
      params.currentPage,
      params.maxPerPage,
      params.sortBy,
      params.sortDir
    ).subscribe(
      data=>{this.listOnSuccess(data)},
      err=>{this.listOnError(err,params)}
    );
  }

  public listOnError(err, params)
  {
      this.err=err;
      this._busy=false;
    /*
    .subscribe(
      result=>{
         //debugger;
         localStorage.setItem('_token', result.token);
         localStorage.setItem('_refreshToken', result.refresh_token);
         if(callback!=null) callback(callback_params);
      },
      err=>{
        if(callback_error!=null) callback_error(err);
      }
    );*/
  }

  public listOnSuccess(data)
  {    
    this.listData=data, this.listItems=(<iListDataResponse>data).items, this._busy=false;
  }

  public get filterData(): any
  {
      return this._filterData;
  }

  public set filterData(value: any)
  {
      this._filterData=value;           
  }

  public get error_message():string
  {
      if(this.err == undefined) {return '';}

      if(this.err.message.indexOf(': 500 Internal Server Error')>0)
      {
        return 'Oops! The Data Service encountered an issue. Please contact support.';
      }
      else if(this.err.message.indexOf(': 401 Unauthorized')>0)
      {

        return 'Your session timed out. Please log in again.';
      }

      return this.err.message;
  }

 

  public get listConfig(): CrudListConfiguration
  {
      return this._listConfig;
  }  

  public get filterConfig():Array<FilterColumn>
  {    
    return this._listConfig.filterConfig;
  }

  public get columnConfigKeys()
  {      
      return Array.from(this.listConfig.columnConfig.keys());
  }

  public get dataItemKeys()
  {
    return Array.from(this.listData.keys());
  }  

  @Input()
  public set listConfig(value: CrudListConfiguration)
  {
     this._listConfig = value;

     this._filterData = Array();

     this._listConfig.filterConfig.forEach(filterCol => {
          this._filterData[filterCol.field_name] = {
              "op": filterCol.default_operator,
              "value1":"",
              "value2":""
          };
      });         

      this.getList(this.filter.form);
  }  

  public get currentPage(): number
  {
    return this._currentPage;
  }

  public set currentPage(value: number)
  {
    this._currentPage = value;
    this.getList(this.filter.form);
  }

  public set sort(field_name:string)
  {
      var col_found:boolean=false;

      this.listConfig.columnConfig.forEach((val,idx)=>{
          if(val.field_name==field_name && val.sortable)
          {
             col_found=true;
          }
      });

      if(!col_found) return;

      if(this.listConfig.sortBy==field_name)
      {
        this.listConfig.sortDir=this.listConfig.sortDir=="asc"?"desc":"asc";
      }
      else
      {
        this.listConfig.sortBy=field_name;
        this.listConfig.sortDir="asc";
      }
      this._currentPage=1;
      this.getList(this.filter.form);
  }

  public get sort():string
  {
    return this.listConfig.sortBy;
  }

  public get sortDir():string
  {
    return this.listConfig.sortDir;
  }

  public get actionColumnRequired():boolean{
    return this.listConfig.allowDelete||this.listConfig.allowEdit||this.listConfig.allowShow||this.listConfig.customObjectActions.length>0;
  }

  public get columnCount():number{
    return 1 + this.listConfig.columnConfig.length + (this.actionColumnRequired?1:0);
  }

  public hasLoaded():boolean{
    return !this._listConfig==null;
  }

  public doAction(actionType:string, data:any)
  {
      this.onAction.emit(new ActionArgs(actionType,data,this));
  }
}



// WEBPACK FOOTER //
// I:/Yog/Projects/Web/LetterDev/wwwroot/ManagerApp/wwwroot/src/app/shared/modules/crud/crud-list/crud-list.component.ts